import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ROUTES, postLoginRedirectPath } from '../routes';

/** `/` — send signed-in users to the right home (admin dashboard vs editorial). */
export const HomeRedirect: React.FC = () => {
  const { isAuthenticated, isAuthReady, user } = useAuth();
  if (!isAuthReady) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-neutral-50">
        <span className="h-8 w-8 animate-spin rounded-full border-4 border-blue-500 border-t-transparent" />
      </div>
    );
  }
  if (!isAuthenticated || !user) return <Navigate to={ROUTES.LOGIN} replace />;
  return <Navigate to={postLoginRedirectPath(user.role, null)} replace />;
};
